import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Bestellen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_card = _resolveComponent("n-card")!
  const _component_Recipient = _resolveComponent("Recipient")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    ref: "formRef",
    model: _ctx.formData
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_space, {
        size: 16,
        vertical: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.service.attributes, (attribute) => {
            return (_openBlock(), _createBlock(_component_n_card, {
              key: attribute.id,
              "theme-overrides": {
            borderColor: _ctx.themeVars.placeholderColor,
          },
              class: "shadow-xl"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(`${attribute.type}_`), {
                  modelValue: _ctx.formData[attribute.id],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[attribute.id]) = $event),
                  attribute: attribute
                }, null, 8, ["modelValue", "onUpdate:modelValue", "attribute"]))
              ]),
              _: 2
            }, 1032, ["theme-overrides"]))
          }), 128)),
          _createVNode(_component_n_card, {
            "theme-overrides": {
          borderColor: _ctx.themeVars.placeholderColor,
        },
            class: "shadow-xl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Recipient, {
                modelValue: _ctx.formData['person_id'],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData['person_id']) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["theme-overrides"]),
          _createVNode(_component_n_button, {
            size: "large",
            type: "primary",
            disabled: _ctx.formData['person_id'] == null,
            block: "",
            onClick: _ctx.formValidate
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}